import { ACTIONS } from './index';

export function changeTab(tab) {
   return {
       type: ACTIONS.CHANGE_TAB,
       payload: tab
   }
}

export function registerTab(tab) {
  return {
    type: ACTIONS.REGISTER_TAB,
    payload: tab
  }
}
